export default "/_next/static/images/texture-5-a353746f7fb0f1c870f74d3da80bfa1f.png";